import { Component, OnDestroy, OnInit } from "@angular/core";
import { TreeService } from "./tree.service";
import { TreeNode } from "primeng/api";


@Component({
    selector: 'ngx-tree',
    styleUrls: ['./tree.component.scss'],
    templateUrl: './tree.component.html',
})
export class TreeComponent implements OnInit, OnDestroy{

    files!: TreeNode[];

    selectedFile!: TreeNode;
    
    constructor(private treeService : TreeService){}
    ngOnDestroy(): void {
        throw new Error("Method not implemented.");
    }
    ngOnInit(): void {
        this.treeService.getFiles().then((data) => (this.files = data));
    }


    
}